module.exports = __webpack_public_path__ + "static/media/smeg-filter.e6208ea7.jpeg";